import React, { Component } from "react";
import Times from "./times.js";
import Calendar from "./calendar.js";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import "./styles.css";
import { getCalendar, getTimes, connectParties, getTutor } from "./database/database";
import dayjs from 'dayjs';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormHelperText from '@mui/material/FormHelperText';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

// import LoadingButton from '@mui/lab/LoadingButton';




export default class BasicDateCalendar extends Component  {

  // .add(2, 'day')

  state = {
    calendar: dayjs(new Date()),
    availability: undefined,
    times: undefined,
    selectedTime: "",
    name: "",
    email: "",
    subjects: [],
    loadingConnectParties: false
  }

  async componentDidMount(){
    const availability = await getCalendar();
    console.log(availability)
    this.setState({availability}, () => this.calculateTimes());
  }

  async calculateTimes() {
    const { calendar, availability, subjects } = this.state;
    const day = calendar.format('dddd').toLowerCase();
    console.log(day)
    // const times = Object.keys(availability[day]);
    const times = await getTimes(day, subjects)
    console.log(times)
    this.setState({times})
  }

  calendarChange(newValue){
    console.log(newValue)
    this.setState({calendar: newValue}, () => this.calculateTimes())
  }

  handleTimeSelection(time){
     this.setState({selectedTime: time});
  }

  async onSubmit() {
    const { selectedTime, calendar, name, email, subjects } = this.state;
    const day = calendar.format('dddd').toLowerCase();
    const tutor = await getTutor(day, selectedTime, subjects);
    const student = {name, email};
    this.setState({loadingConnectParties: true}, () => (
      connectParties({tutor, student, subject:subjects, time: selectedTime, date: calendar.format("MM-DD-YYYY"), day})
    ))
  }


  goBack() {
    this.setState({selectedTime: ""})
  }

  render(){
    const { calendar, times, selectedTime, name, email, subjects, loadingConnectParties } = this.state;
    return (
      <div style = {{display: "flex", width: "100%", justifyContent: "center", alignItems: "center"}} className = "container flex-container">
        <div style = {{visibility: "scroll"}} className = "border rounded-4 px-2 py-5 px-md-5 col-12 col-md-9 main-box">
        <h1 className = "main-header">Welcome To Trusty Teens!</h1>
        <p>Please book a time with one of our verified volunteer tutors.</p>
        <p>(Note: for ease, only available time-slots will be shown.  also if you can't find your desired subject, please select the one that is closest to it)</p>
        {selectedTime?(
          <>
          <IconButton aria-label="delete" size="small" onClick = {() => this.goBack()}>
            <ArrowBackIcon fontSize="small" />
          </IconButton>
          <h5 className = "my-3">Get Tutored At {selectedTime} on {calendar.format('MM-DD-YYYY')}</h5>
          <TextField id="outlined-basic" label="Your Full Name" variant="outlined"  className = "my-3 m-2" value = {name} onChange = {(event) => this.setState({name: event.target.value})}/><br/>
          <TextField id="outlined-basic" label="Your Personal Email" variant="outlined" className = "my-3 m-2" value = {email} onChange = {(event) => this.setState({email: event.target.value})}/><br/>
          <Button variant="contained" className = "mt-3 mb-1" onClick = {() => this.onSubmit()} disabled = {loadingConnectParties}> <spam>Book</spam> </Button>
          {loadingConnectParties?<div><CircularProgress/> <p>Connecting... DO NOT RELOAD THE PAGE</p></div>:""}
          <FormHelperText id="component-helper-text">
          You can always cancel later.
        </FormHelperText>
          </>
        ):(
          <>
                  <Autocomplete
              multiple
              id="tags-outlined"
              options={["2nd Grade","3rd Grade", "4th Grade","5th Grade","6th Grade","7th Grade","8th Grade","Pre-Algebra (7th and 8th grade math)","Algebra I (or 9th grade Math)", "Geometry (or 10th grade math)","Algebra II (or 11th graade math)", "Pre Calculus (or 12th grade math)", "Calculus AB", "Calculus BC", "English 9th grade", "English 10th grade", "English 11th grade", "English 12th grade", "AP Literature", "Research", "AP Human Geography", "World History", "European History", "US History or AP US History", "Economics", "Government", "Chemistry", "AP Chemistry", "Biology", "AP Biology", "Physics", "AP Physics"]}
              getOptionLabel={(option) => option}
              className = "my-4"
              value = {subjects}
              onChange = {(event, newValue) => this.setState({subjects: newValue}, () => this.calculateTimes())}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subjects"
                  placeholder="Subjects"
                />
              )}
            />
          <div className = "d-flex row" style = {{justifyContent: "start", visibility: "scroll", height: "50%"}}>
          <Calendar calendar = {calendar} onChange = {(newValue) => this.calendarChange(newValue)}></Calendar>
          {times?<Times times = {times} handleTimeSelection ={(props) => this.handleTimeSelection(props)} selectedTime = {selectedTime}></Times>:""}
          </div>
          </>
        )}
        </div>
      </div>
    );
  }
}
